import { createContext, useContext } from 'react'
import type { GateType } from '@/types/player-detail'

export interface PendingGateRevocationsValue {
    pending: ReadonlySet<GateType>
    markQueued: (gateType: GateType) => void
}

export const PendingGateRevocationsContext = createContext<PendingGateRevocationsValue | undefined>(
    undefined,
)

const NOOP_VALUE: PendingGateRevocationsValue = {
    pending: new Set(),
    markQueued: () => {},
}

export function usePendingGateRevocations(): PendingGateRevocationsValue {
    return useContext(PendingGateRevocationsContext) ?? NOOP_VALUE
}
